import ErrorBoundary from "./ErrorBoundary";
import { BasePageProps } from "../types/components";

function HomePage({ userMode, userAge }: BasePageProps) {
  return (
    <ErrorBoundary>
      <div>
        <h1>Find a Feeling</h1>
        <h2>About Somatic Awareness</h2>
        {userMode && (
          <div>
            <p>Mode: {userMode}</p>
            {userAge && <p>Age: {userAge}</p>}
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
}

export default HomePage;
